import React, { useState, useEffect, useRef } from "react";
import { FaBars, FaTimes, } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";

import logo3 from "../assets/images/Navbar/image21.png";
import logo2 from "../assets/images/Navbar/rightlogo1.png";
import logo1 from "../assets/images/Navbar/image211.png";

import attractionleftside from "../assets/images/Navbar/attractionleftside.png";
import attractionrightside from "../assets/images/Navbar/attractionrightside.png";
import {useSelector } from "react-redux";
import lightArrow from "../assets/images/Navbar/arrow-next-small 1.svg";
import darkArrow from "../assets/images/Navbar/arrow2.svg";
import AccessibilityHeader from "./AccessibilityHeader";
import actandlaws from "../assets/images/Navbar/actandlaws.png";
import overview from "../assets/images/Navbar/overview-icon.svg";
import awardsandscholership from "../assets/images/Navbar/Awards & Scholarships.svg";
import adminstructure from "../assets/images/Navbar/Administrative Structure.svg";
import scheme from "../assets/images/Navbar/Scheme.svg";
import Museum from "../assets/images/Navbar/museum.svg";
import Mouments from "../assets/images/Navbar/Monuments.svg";
import excavations from "../assets/images/Navbar/Excavations.svg";
import conversation from "../assets/images/Navbar/Conservation.svg";
import publication from "../assets/images/Navbar/Publication.svg";
import rti from "../assets/images/Navbar/RTI.svg";
import filming from "../assets/images/Navbar/Filming.svg";
import permissionforevent from "../assets/images/Navbar/Permission for the Event.svg";
import GRs from "../assets/images/Navbar/GRs.svg";
import citizencharter from "../assets/images/Navbar/Citizen Charter.svg";
import circulars from "../assets/images/Navbar/Circulars.svg";
import senioritylist from "../assets/images/Navbar/Seniority List.svg";


const Navbar = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);
  const location = useLocation();
  const currentPath = location.pathname;
  // const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState("");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // const langRef = useRef(null);
  const navRef = useRef(null);

  const [fontSizeLevel, setFontSizeLevel] = useState(0);
  const [colorTheme, setColorTheme] = useState("default");


  useEffect(() => {
    const baseSize = 16; // 16px default
    document.documentElement.style.fontSize = `${baseSize + fontSizeLevel * 2}px`;
  }, [fontSizeLevel]);

  useEffect(() => {
    document.body.classList.remove("theme-default", "theme-dark", "theme-sepia");
    document.body.classList.add(`theme-${colorTheme}`);
  }, [colorTheme]);


  useEffect(() => {
    setMobileMenuOpen(false);
    setActiveDropdown("");
  }, [location.pathname]);



  useEffect(() => {
    // Close mobile menu when route changes
    setMobileMenuOpen(false);
    setActiveDropdown(""); // Optional: close dropdown too
  }, [location.pathname]);

  const headerLogos = {
    English: {
      default: {
        logo1: logo1,
        logo2: logo2,
        logo3: logo3,
      },
      black: {
        logo1: logo1,
        logo2: logo2,
        logo3: logo3,
      },
    },

    मराठी: {
      default: {
        logo1: logo1,
        logo2: logo2,
        logo3: logo3,
      },
      black: {
        logo1: logo1,  // left Marathi black logo
        logo2: logo2,    // right logo (change if needed)
        logo3: logo3,  // center Marathi black logo
      },
    },
  };



  const currentTheme = colorTheme === "black" ? "black" : "default";
  const { logo1: dirLogo, logo2: govLogo, logo3: centerLogo } = headerLogos[selectedLang][currentTheme];

  const navContent = {
    English: {
      navItems: [
        { id: 1, label: "HOME", link: "/" },
        { id: 2, label: "ABOUT US", link: "#" },
        { id: 3, label: "DEPARTMENT", link: "#" },
        { id: 4, label: "PERMISSION & LICENSE", link: "#" },
        { id: 5, label: "PRESERVATION AND CONSERVATION", link: "/conversation" },
        { id: 6, label: "RESOURCES", link: "#" },
        { id: 12, label: "WORLD HERITAGE", link: "/worldheritage" },
        { id: 7, label: "GALLERY", link: "/gallery" },
        { id: 8, label: "TENDERS", link: "/tenders" },
        { id: 9, label: "DASHBOARD", link: "/dashboard" },
        { id: 10, label: "SHOP", link: "/shop" },
        { id: 11, label: "CONTACT US", link: "/contact" },
      ],
      searchPlaceholder: "Search For Monuments, Museum Or District",
      loginText: "LOG IN",
      dropdownData: {
        "ABOUT US": {
          links: [
            { id: 1, icon: <img src={overview} alt="Overview" className="w-4 h-4 object-contain yellow-icon" />, label: "About us", link: "/overview" },
            { id: 2, icon: <img src={adminstructure} alt="Administrative Structure" className="w-4 h-4 object-contain yellow-icon" />, label: "Administrative Set-Up/ Administration", link: "/adminstructure" },
            { id: 3, icon: <img src={awardsandscholership} alt="Awards & Scholarships" className="w-4 h-4 object-contain yellow-icon" />, label: "Awards", link: "/awards" },
            { id: 4, icon: <img src={scheme} alt="Schemes" className="w-4 h-4 object-contain yellow-icon" />, label: "Schemes & Projects", link: "/scheme" },
            { id: 5, icon: <img src={scheme} alt="Recruitment" className="w-4 h-4 object-contain yellow-icon" />, label: "Recruitment", link: "/recruitment" },
          ],
        },
        "DEPARTMENT": {
          links: [
            { id: 1, icon: <img src={Museum} alt="Museums" className="w-4 h-4 object-contain yellow-icon" />, label: "Museums", link: "/museums" },
            { id: 2, icon: <img src={Mouments} alt="Monuments" className="w-4 h-4 object-contain yellow-icon" />, label: "Monuments and Sites", link: "/monuments" },
            { id: 3, icon: <img src={Museum} alt="Report Antiquities" className="w-4 h-4 object-contain yellow-icon" />, label: "Report Antiquities", link: "/reportantiquities" },
          ],
          leftLogo: attractionleftside,
          rightLogo: attractionrightside,
        },
        "PERMISSION & LICENSE": {
          links: [
            { id: 1, icon: <img src={filming} alt="Filming" className="w-4 h-4 object-contain yellow-icon" />, label: "Film/Video Shooting", link: "/film-shooting" },
            { id: 2, icon: <img src={permissionforevent} alt="Permission for the Event" className="w-4 h-4 object-contain yellow-icon" />, label: "Gateway of India Event Permission", link: "/event-permission" },
            { id: 3, icon: <img src={filming} alt="Other State Protected Monuments Event Permission" className="w-4 h-4 object-contain yellow-icon" />, label: "Other State Protected Monuments Event Permission", link: "/monumenteventpermission" },
            { id: 4, icon: <img src={filming} alt="Development NOC" className="w-4 h-4 object-contain yellow-icon" />, label: "Development NOC", link: "/NOCDevelopement" },
            { id: 5, icon: <img src={filming} alt="Research Permissions" className="w-4 h-4 object-contain yellow-icon" />, label: "Research Permissions", link: "/researchpermission" },
          ],
        },
        "RESEARCH": {
          links: [
            { id: 1, icon: <img src={conversation} alt="Preservation and Conservation" className="w-4 h-4 object-contain yellow-icon" />, label: "Preservation and Conservation", link: "/conversation" },
          ],
        },
        "RESOURCES": {
          links: [
            { id: 1, icon: <img src={actandlaws} alt="Acts & Laws" className="w-4 h-4 object-contain yellow-icon" />, label: "Legislations", link: "/legislations" },
            { id: 2, icon: <img src={GRs} alt="GRs" className="w-4 h-4 object-contain yellow-icon" />, label: "GRs", link: "/gov-resolutions" },
            { id: 3, icon: <img src={circulars} alt="Circulars" className="w-4 h-4 object-contain yellow-icon" />, label: "Circulars", link: "/circulars" },
            { id: 4, icon: <img src={citizencharter} alt="Court Orders " className="w-4 h-4 object-contain yellow-icon" />, label: "Court Orders", link: "/courtorder" },
            { id: 5, icon: <img src={publication} alt="Publication" className="w-4 h-4 object-contain yellow-icon" />, label: "Publication", link: "/publication" },
            { id: 6, icon: <img src={excavations} alt="Excavations and Explorations" className="w-4 h-4 object-contain yellow-icon" />, label: "Exploration & Excavation", link: "/excavations" },
            { id: 7, icon: <img src={citizencharter} alt="Citizen Charter" className="w-4 h-4 object-contain yellow-icon" />, label: "Citizen Charter", link: "/citizen-charter" },
            { id: 8, icon: <img src={rti} alt="Library" className="w-4 h-4 object-contain yellow-icon" />, label: "RTI", link: "/rti" },
            { id: 9, icon: <img src={senioritylist} alt="Seniority List" className="w-4 h-4 object-contain yellow-icon" />, label: "Seniority List", link: "/senioritylist" },
          ],
        },
      },
    },


    मराठी: {
      navItems: [
        { id: 1, label: "मुख्यपृष्ठ ", link: "/" },
        { id: 2, label: "परिचय", link: "#" },
        { id: 3, label: "प्रशासन", link: "#" },
        { id: 4, label: "परवानगी आणि परवाना", link: "#" },
        { id: 5, label: "जतन आणि संवर्धन", link: "/conversation" },
        { id: 6, label: "संसाधने", link: "#" },
        { id: 12, label: "जागतिक वारसा", link: "/worldheritage" },
        { id: 7, label: "दालन", link: "/gallery" },
        { id: 8, label: "निविदा", link: "/tenders" },
        { id: 9, label: "डॅशबोर्ड", link: "/dashboard" },
        { id: 10, label: "शॉप", link: "/shop" },
        { id: 11, label: "संपर्क साधा", link: "/contact" },

      ],
      searchPlaceholder: "स्मारके, संग्रहालय किंवा जिल्हा शोधा",
      loginText: "लॉग इन",
      dropdownData: {
        "परिचय": {
          links: [
            { id: 1, icon: <img src={overview} alt="Overview" className="w-4 h-4 object-contain yellow-icon" />, label: "परिचय", link: "/overview" },
            { id: 2, icon: <img src={awardsandscholership} alt="Awards & Scholarships" className="w-4 h-4 object-contain yellow-icon" />, label: "पुरस्कार", link: "/awards" },
            { id: 3, icon: <img src={adminstructure} alt="Administrative Structure" className="w-4 h-4 object-contain yellow-icon" />, label: "प्रशासकीय रचना / प्रशासन", link: "/adminstructure" },
            { id: 4, icon: <img src={scheme} alt="Schemes" className="w-4 h-4 object-contain yellow-icon" />, label: "योजना आणि प्रकल्प", link: "/scheme" },
            { id: 5, icon: <img src={scheme} alt="Recruitment" className="w-4 h-4 object-contain yellow-icon" />, label: "भरती", link: "/recruitment" },
          ],
        },
        "प्रशासन": {
          links: [
            { id: 1, icon: <img src={Museum} alt="Museums" className="w-4 h-4 object-contain yellow-icon" />, label: "संग्रहालये", link: "/museums" },
            { id: 2, icon: <img src={Mouments} alt="Monuments" className="w-4 h-4 object-contain yellow-icon" />, label: "स्मारके व पुरास्थळे", link: "/monuments" },
            { id: 3, icon: <img src={Museum} alt="Report Antiquities " className="w-4 h-4 object-contain yellow-icon" />, label: "नोंदणी करा - पुरावशेष, पुरावस्तू व पुरावास्तू", link: "/reportantiquities" },
          ],
        },
        "परवानगी आणि परवाना": {
          links: [
            { id: 1, icon: <img src={filming} alt="Filming" className="w-4 h-4 object-contain yellow-icon" />, label: "चित्रपट/व्हिडिओ शूटिंग", link: "/film-shooting" },
            { id: 2, icon: <img src={permissionforevent} alt="Permission for the Event" className="w-4 h-4 object-contain yellow-icon" />, label: "गेटवे ऑफ इंडिया कार्यक्रमाची परवानगी", link: "/event-permission" },
            { id: 3, icon: <img src={filming} alt="Other State Protected Monuments Event Permission" className="w-4 h-4 object-contain yellow-icon" />, label: "इतर राज्य संरक्षित स्मारकांच्या कार्यक्रमाची परवानगी", link: "/monumenteventpermission" },
            { id: 4, icon: <img src={filming} alt="Development NOC" className="w-4 h-4 object-contain yellow-icon" />, label: "विकास एनओसी", link: "/NOCDevelopement" },
            { id: 5, icon: <img src={filming} alt="Research Permissions" className="w-4 h-4 object-contain yellow-icon" />, label: "संशोधन परवानग्या", link: "/researchpermission" },
          ],
        },
        "संशोधन": {
          links: [
            { id: 1, icon: <img src={conversation} alt="Preservation and Conservation" className="w-4 h-4 object-contain yellow-icon" />, label: "जतन आणि संवर्धन", link: "/conversation" },
          ],
        },
        "संसाधने": {
          links: [
            { id: 1, icon: <img src={actandlaws} alt="Acts & Laws" className="w-4 h-4 object-contain yellow-icon" />, label: "अधिनियम ", link: "/legislations" },
            { id: 2, icon: <img src={GRs} alt="GRs" className="w-4 h-4 object-contain yellow-icon" />, label: "शासन निर्णय", link: "/gov-resolutions" },
            { id: 3, icon: <img src={circulars} alt="Circulars" className="w-4 h-4 object-contain yellow-icon" />, label: "परिपत्रक", link: "/circulars" },
            { id: 4, icon: <img src={citizencharter} alt="Court Orders" className="w-4 h-4 object-contain yellow-icon" />, label: "न्यायालयीन आदेश", link: "/courtorder" },
            { id: 5, icon: <img src={publication} alt="Publication" className="w-4 h-4 object-contain yellow-icon" />, label: "प्रकाशने", link: "/publication" },
            { id: 6, icon: <img src={excavations} alt="Excavations and Explorations" className="w-4 h-4 object-contain yellow-icon" />, label: "अन्वेषण आणि उत्खनन", link: "/excavations" },
            { id: 7, icon: <img src={citizencharter} alt="Citizen Charter" className="w-4 h-4 object-contain yellow-icon" />, label: "नागरिकांची सनद", link: "/citizen-charter" },
            { id: 8, icon: <img src={rti} alt="RTI" className="w-4 h-4 object-contain yellow-icon" />, label: "माहितीचा अधिकार", link: "/rti" },
            { id: 9, icon: <img src={senioritylist} alt="Seniority List" className="w-4 h-4 object-contain yellow-icon" />, label: "ज्येष्ठता सूची", link: "/senioritylist" },
          ],
        },
      },
    },
  };

  const { navItems, dropdownData } = navContent[selectedLang];


  // Search Functionality
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const prevPath = useRef(location.pathname); // track the previous path

  // Existing search useEffect
 useEffect(() => {
    const trimmed = query.trim();
    const timeout = setTimeout(() => {
        if (trimmed) {
            if (!location.pathname.startsWith("/search")) {
                prevPath.current = location.pathname;
            }
            navigate(`/search?query=${encodeURIComponent(trimmed)}`);
        }

        if (!trimmed && location.pathname.startsWith("/search")) {
            navigate(prevPath.current || "/");
        }
    }, 400);
    return () => clearTimeout(timeout);
}, [query, location.pathname, navigate]);

  // New useEffect to clear query when not on /search
  useEffect(() => {
    if (!location.pathname.startsWith("/search")) {
      setQuery("");
    }
  }, [location.pathname]);


  useEffect(() => {
    const handleClickOutside = (e) => {
      // Check only for language dropdown
      // if (langRef.current && !langRef.current.contains(e.target)) {
      //   setIsOpen(false);
      // }

      // Check for nav dropdown (like ABOUT US, etc.)
      if (navRef.current && !navRef.current.contains(e.target)) {
        setActiveDropdown("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="font-futura tracking-wide shadow-sm border-b bg-white relative" ref={navRef}>
      {/* Accessibility Bar */}
      <div className="fixed top-0 left-0 w-full z-50">
        <AccessibilityHeader
          fontSizeLevel={fontSizeLevel}
          setFontSizeLevel={setFontSizeLevel}
          colorTheme={colorTheme}
          setColorTheme={setColorTheme}
        />
      </div>
      {/* Top Section */}
      <div className="pt-32 sm:pt-12 md:pt-36 lg:pt-24 xl:pt-12">
        <div className="flex flex-col  lg:flex-row justify-between items-center gap-4 lg:gap-20 p-4 px-4 lg:px-16">
          {/* <div className="flex items-center justify-between w-full">
          <Link to="/">
            <div className="flex items-center gap-3">
              <img src={dirLogo} alt="Logo" className="h-14 w-auto" />
            </div>
          </Link>

          <div className="flex items-center gap-2">
            <img src={govLogo} alt="Logo" className="h-14 w-auto" />
          </div>
        </div> */}

          {/* LEFT + CENTER + RIGHT LOGO WRAPPER */}
          <div className="relative flex items-center justify-between w-full py-3">

            {/* LEFT LOGO */}
            {/* <Link to="/" className="flex items-center z-10">
            <img
              src={dirLogo}
              alt="Left Logo"
              className="h-12 sm:h-16 md:h-20 w-auto"
            />
          </Link> */}
            <Link
              to="/"
              className="flex flex-col items-center z-10 text-center max-w-[95px] sm:max-w-[150px] md:max-w-[180px]"
            >
              {/* LEFT LOGO */}
              <img
                src={dirLogo}
                alt="Left Logo"
                className="h-8 sm:h-10 md:h-13 lg:h-14 w-auto mb-[1px]"
              />

              {/* LEFT TEXT */}
              {selectedLang === "English" ? (
                <>
                  <p className="text-[8px] sm:text-[9px] md:text-[10px] lg:text-[11px] font-medium text-black leading-tight m-0 break-words">
                    Government of Maharashtra
                  </p>
                  <p className="text-[10px] sm:text-[11px] md:text-[12px] lg:text-[13px] font-semibold text-black leading-tight m-0 break-words">
                    Department of Cultural Affairs
                  </p>
                </>
              ) : (
                <>
                  <p className="text-[9px] sm:text-[10px] md:text-[11px] lg:text-[12px] font-medium text-black leading-tight m-0 break-words">
                    महाराष्ट्र शासन
                  </p>
                  <p className="text-[9px] sm:text-[12px] md:text-[13px] lg:text-[14px] font-semibold text-black leading-tight m-1 break-words">
                    सांस्कृतिक कार्य विभाग
                  </p>
                </>
              )}
            </Link>



            {/* CENTER LOGO */}
            {/* <div className="absolute left-1/2 -translate-x-1/2 flex items-center">
            <img
              src={centerLogo}
              alt="Center Logo"
              className="h-14 sm:h-20 md:h-24 w-auto"
            />
          </div> */}

            {/* CENTER TEXT LOGO */}
            <div className="absolute left-1/2 -translate-x-1/2 flex flex-col items-center text-center px-2">

              {/* CENTER LOGO */}
              <img
                src={centerLogo}
                alt="Center Logo"
                className="h-12 sm:h-16 md:h-20 lg:h-16 w-auto mb-1 sm:mb-2"
              />

              {/* CENTER TEXT */}
              {selectedLang === "English" ? (
                <>
                  <p className="text-[11px] sm:text-[13px] md:text-[15px] font-semibold text-orange-500 leading-none m-0">
                    Government of Maharashtra
                  </p>
                  <p className="text-[15px] sm:text-[18px] md:text-[24px] font-bold text-orange-500 leading-none m-0">
                    Directorate of Archaeology and Museums
                  </p>
                </>
              ) : (
                <>
                  <p className="text-[13px] sm:text-[15px] md:text-[12px] lg:text-[17px] font-semibold text-orange-500 leading-none m-0t">
                    महाराष्ट्र शासन
                  </p>
                  <p className="text-[17px] sm:text-[20px] md:text-[20px] lg:text-[26px] font-bold text-orange-500 leading-none m-2">
                    पुरातत्त्व व वस्तुसंग्रहालये संचालनालय
                  </p>
                </>
              )}

            </div>

            {/* RIGHT LOGO */}
            <div className="flex items-center z-10">
              <img
                src={govLogo}
                alt="Right Logo"
                className="h-12 sm:h-16 md:h-20 w-auto"
              />
            </div>
          </div>

          {/* MOBILE NAV ICON (only on mobile) */}
          <div className="flex items-center justify-end w-full mt-3 lg:mt-0 lg:hidden">
            <button
              aria-label="Open menu"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="ml-1"
            >
              {mobileMenuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
            </button>
          </div>

        </div>
      </div>

      {/* Navigation */}
      <nav id="main-nav" className={`bg-white md:scroll-mt-36 lg:scroll-mt-24 xl:scroll-mt-12 ${mobileMenuOpen ? "block" : "hidden"} lg:block`}>
        <ul className="flex flex-col lg:flex-row lg:justify-center lg:gap-3.5 text-sm font-medium py-2 px-4">
          {navItems.map(({ id, label, link }) => {
            const hasDropdown = Boolean(dropdownData[label]);
            const dropdownLinks = dropdownData[label]?.links?.map((item) => item.link) || [];

            const isActive =
              currentPath === link ||
              dropdownLinks.some((childPath) => currentPath.startsWith(childPath));

            return (
              <li key={id} className="relative group cursor-pointer py-2 lg:py-0">
                {hasDropdown ? (
                  <button
                    className="flex items-center gap-1 group select-none no-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setActiveDropdown(activeDropdown === label ? "" : label);
                    }}
                  >
                    {/* Extracted spanClass logic */}
                    {(() => {
                      let spanClass = "border-b-2 transition ";

                      if (activeDropdown === label || isActive) {
                        spanClass += colorTheme === "black"
                          ? "border-yellow-300 text-white"
                          : "border-black text-black";
                      } else {
                        spanClass += colorTheme === "black"
                          ? "border-transparent group-hover:border-yellow-300 text-white"
                          : "border-transparent group-hover:border-black text-gray-800";
                      }

                      return (
                        <span className={spanClass}>
                          {label}
                        </span>
                      );
                    })()}

                    <img
                      src={colorTheme === "black" ? darkArrow : lightArrow}
                      alt="arrow"
                      className="w-4 h-4 transition no-btn"
                    />
                  </button>
                ) : (
                  <Link
                    to={link}
                    className={(() => {
                      let baseClass = "flex items-center gap-1 border-b-2 transition ";
                      if (isActive) {
                        return baseClass + (colorTheme === "black"
                          ? "border-yellow-300 text-white"
                          : "border-black text-black");
                      } else {
                        return baseClass + (colorTheme === "black"
                          ? "border-transparent hover:border-yellow-300 text-white"
                          : "border-transparent hover:border-black text-gray-800");
                      }
                    })()}
                    onClick={() => setActiveDropdown("")}
                  >
                    {label}
                  </Link>
                )}

                {/* Mobile dropdown */}
                {mobileMenuOpen && hasDropdown && activeDropdown === label && (
                  <div
                    className={`py-2 px-4 border-t ${colorTheme === "dark"
                      ? "bg-black border-gray-700"
                      : "bg-[#f3f0e7] border-gray-200"
                      }`}
                  >
                    {dropdownData[label].links.map(({ id, icon, label, link }) => (
                      <div
                        key={id}
                        className="flex items-center gap-3 py-2 transition cursor-default"
                      >
                        <Link
                          to={link}
                          className="group flex items-center gap-3 pointer-events-auto"
                          onClick={() => {
                            setActiveDropdown("");
                            setMobileMenuOpen(false);
                          }}
                        >
                          <span
                            className={`text-lg transition group-hover:border-b-2 ${colorTheme === "dark"
                              ? "text-white group-hover:text-white group-hover:border-white"
                              : "text-gray-700 group-hover:text-gray-900 group-hover:border-black"
                              }`}
                          >
                            {icon}
                          </span>
                          <span
                            className={`transition tracking-wider group-hover:border-b-2 ${colorTheme === "dark"
                              ? "text-white group-hover:text-white group-hover:border-white"
                              : "text-gray-700 group-hover:text-gray-900 group-hover:border-black"
                              }`}
                          >
                            {label}
                          </span>
                        </Link>
                      </div>
                    ))}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Desktop dropdown */}
      {activeDropdown && dropdownData[activeDropdown] && !mobileMenuOpen && (
        <div
          role="menu"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              setActiveDropdown('');
            }
          }}
          onClick={(e) => e.stopPropagation()}
          className="absolute left-0 top-full w-full bg-[#f3f0e7] shadow-md border-t border-gray-300 z-40 navbar-dropdown"
        >
          <div className="flex justify-center w-full py-8 px-8 lg:px-16">
            {/* Grid + Right Logo Container */}
            <div className="flex justify-between items-center w-full">
              {/* Grid Menu with left margin */}
              <div className="grid grid-cols-3 lg:gap-x-12 xl:gap-x-40 gap-y-4 max-w-[800px] lg:ml-16 xl:ml-32">
                {dropdownData[activeDropdown].links.map(({ id, icon, label, link }) => (
                  <div key={id} className="flex items-center gap-2">
                    <Link
                      to={link}
                      className="flex items-center gap-2 transition group"
                      onClick={() => setActiveDropdown("")}
                    >
                      {/* ICON */}
                      <span
                        className={`transition w-5 h-5 ${currentPath.startsWith(link)
                          ? "text-black"
                          : "text-gray-700"
                          }`}
                      >
                        {icon}
                      </span>

                      {/* LABEL */}
                      <span
                        className={`text-sm border-b-2 tracking-wider text-nowrap transition
                           ${colorTheme === "black"
                            ? "text-white group-hover:border-yellow-300"
                            : "text-gray-700 group-hover:border-black"
                          }
                              ${currentPath.startsWith(link) ? "font-semibold" : "border-transparent"}
                                  `}
                      >
                        {label}
                      </span>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

    </header>
  );
};

export default Navbar;
